<template>
    <div>
        <div class="row">
            <div class="col-6 col-md-3 my-2">
                <WalletStat
                        :transactionStatistics="stats.wallets_count"
                        :title="$t('label.wallets_count')"
                        :needCurrency="false"
                >
                </WalletStat>
            </div>

            <div class="col-6 col-md-3 my-2">
                <WalletStat
                        :transactionStatistics="stats.active_wallets_count"
                        :title="$t('label.active_wallets_count')"
                        :needCurrency="false"
                >
                </WalletStat>
            </div>
            <div class="col-6 col-md-3 my-2">
                <WalletStat
                        :transactionStatistics="stats.wallets_balance"
                        :title="$t('label.wallets_balance')"
                        :needCurrency="true"
                >
                </WalletStat>
            </div>
            <div class="col-6 col-md-3 my-2">
                <WalletStat
                        :transactionStatistics="stats.wallets_available_balance"
                        :title="$t('label.wallets_available_balance')"
                        :needCurrency="true"
                >
                </WalletStat>
            </div>
            <div class="col-12" v-show="!prop_user_hashid">
                <div class="d-flex justify-content-end">
                    <button type="button" :disabled="refresh_button_is_loading" @click="adminRefreshAllBalance()">
                        <i v-if="!refresh_button_is_loading" class="flaticon-refresh" style="font-size: 1.6em; color: #0f9af0"></i>
                        <i v-else class="fas flaticon-refresh fa-spin" style="font-size: 1.6em; color: #0f9af0"></i>
                    </button>
                </div>
            </div>
        </div>
        
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <kt-panel>
                    <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)">
                                <kt-form-section>
                                    <kt-form-row>
                                       
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="statusSelectGroup">
                                                <kt-form-label for="status">
                                                    {{ $t('label.status') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="status" class="form-control"
                                                                name="status" v-model="query.status"
                                                >
                                                    <option :value="null" selected v-text="$t('label.all_statuses')"
                                                    ></option>
                                                    <option :value="walletStatus.ACTIVE"
                                                            v-text="walletStatusStr.get(walletStatus.ACTIVE)"
                                                    ></option>
                                                    <option :value="walletStatus.INACTIVE"
                                                            v-text="walletStatusStr.get(walletStatus.INACTIVE)"
                                                    ></option>
                                                   
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                            
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="title"
                                                   v-text="$t('wallets.label.wallet_title')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="title"
                                                   name= "title"
                                                   class="form-control"
                                                   v-model="query.title"
                                            >
                                        </kt-col>

                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="title"
                                                   v-text="$t('label.wallet_hashid')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="wallet_hashid"
                                                   name= "wallet_hashid"
                                                   class="form-control"
                                                   v-model="query.wallet_hashid"
                                            >
                                        </kt-col>

                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="title"
                                                   v-text="$t('label.custom_wage')"
                                            >
                                            </label>
                                            <select class="form-control"
                                                    id="custom_wage"
                                                    name="custom_wage"
                                                    v-model="query.custom_wage"
                                            >
                                                <option :value="null" selected v-text="$t('label.all_statuses')"
                                                ></option>
                                                <option v-text="walletCustomWageStatusStr.get(walletCustomWageStatus.ENABLED)"
                                                        :value="walletCustomWageStatus.ENABLED">
                                                </option>
                                                <option v-text="walletCustomWageStatusStr.get(walletCustomWageStatus.DISABLED)"
                                                        :value="walletCustomWageStatus.DISABLED">
                                                </option>
                                            </select>
                                        </kt-col>
                                        
                                        <kt-col xs="12" sm="3" md="3" class="mb-2" v-show="!prop_user_hashid">
                                            <label for="fullname"
                                                   v-text="$t('label.fullname')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="fullname"
                                                   name= "fullname"
                                                   class="form-control"
                                                   v-model="query.fullname"
                                            >
                                        </kt-col>

                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="instant_settlement_status" v-text="$t('label.instant_settlement_status')"></label>
                                            <select class="form-control"
                                                    id="instant_settlement_status"
                                                    name="instant_settlement_status"
                                                    v-model="query.instant_settlement_status"
                                            >
                                                <option :value="null" selected v-text="$t('label.all_statuses')"
                                                ></option>
                                                <option v-text="instantSettlementStatusStr.get(instantSettlementStatus.ACTIVE)"
                                                        :value="instantSettlementStatus.ACTIVE">
                                                </option>
                                                <option v-text="instantSettlementStatusStr.get(instantSettlementStatus.INACTIVE)"
                                                        :value="instantSettlementStatus.INACTIVE">
                                                </option>
                                            </select>
                                        </kt-col>

                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label class="switch">
                                                <input id="has_blocked_amount_checkbox" type="checkbox" v-model="query.has_blocked_amount">
                                                <span class="slider round"></span>
                                            </label>
                                            {{ $t('label.has_blocked_amount') }}
                                        </kt-col>

                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label class="switch">
                                                <input id="has_upcoming_settlement_checkbox" type="checkbox" v-model="query.has_upcoming_settlement">
                                                <span class="slider round"></span>
                                            </label>
                                            {{ $t('label.has_upcoming_settlement') }}
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" class="mt-4">
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </kt-panel>
            </div>
        </div>


        <div class="bg-white shadow-sm">
            <kt-datatable ref="datatable" v-bind="datatableProps">
            </kt-datatable>
        </div>
    </div>
</template>

<script>
    import {walletStatus,walletStatusStr} from "@/constants/walletStatus.js"
    import {ApiUrl, walletService} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import columns from "@/views/wallets/AyandeWallets/Admin/datatable/columns";
    import actions from "@/views/wallets/AyandeWallets/Admin/datatable/actions";
    import WalletStat from '@/views/transaction/components/transaction-statistic';
    import {instantSettlementStatusStr, instantSettlementStatus} from "@/constants/instantSettlementStatus";
    import {walletCustomWageStatusStr, walletCustomWageStatus} from "@/constants/walletCustomWageStatus";
    import {i18n} from "@/plugins/i18n";
    import {STAR_SHOP_BASE_URL} from "@/common/config";

    export default {
        components: {
            WalletStat,
        },
        data() {
            return {
                walletStatus,
                walletStatusStr,
                instantSettlementStatusStr,
                instantSettlementStatus,
                walletCustomWageStatusStr,
                walletCustomWageStatus,
                stats: {
                    wallets_count: 0,
                    active_wallets_count: 0,
                    wallets_balance: 0,
                    wallets_available_balance: 0,
                },
                query: {
                    status: null,
                    instant_settlement_status: null,
                    custom_wage: null,
                    has_blocked_amount: false,
                    has_upcoming_settlement: false,
                    user_hashid: this.prop_user_hashid
                },
                refresh_button_is_loading : false,
            };
        },
        props: {
          prop_user_hashid : {
              required : false
          },
          fetch_starshop: {
            default: false,
            type: Boolean
          },
          api_base_path: {
            default: ApiUrl.path(''),
            type: String
          }
        },
        mounted() {
            if (this.$can('read-statistics', 'wallet')) {
                this.getStats()
            }
        },
        methods: {
            adminRefreshAllBalance() {
                this.refresh_button_is_loading = true;

              walletService.adminRefreshAllBalanc().finally(() => {
                    setTimeout(() => {
                        this.refresh_button_is_loading = false
                    }, 2000)
                });
            },
            filterAction(e, query) {
                this.query = query;

                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
            getStats() {
                const params = { wallet_prefix: 'A' };
                const userHashId = this.prop_user_hashid;
                const fetchFunction =userHashId
                    ? walletService.getCoreStatsByUserHashId
                    : walletService.getCoreStats;

                fetchFunction(params, userHashId)
                    .then(res => {
                        this.stats = res.data.data;
                    })
                    .catch(error => {
                        console.error('Error fetching stats:', error);
                    });
            }
        },
        computed: {
            datatableProps() {
                return {
                    id: "wallets_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('wallet/common/admin/get/A'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: res => {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actions,
                }
            },
        },
    }
</script>

<style scoped>
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #777777;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 12px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
    .slider.round {
        border-radius: 50px;
    }

    .slider.round:before {
        border-radius: 50px;
    }
</style>
